import React, { ComponentProps } from "react";
import "./LinkAsButton.scss";

export default function LinkAsButton({ className, type = "button", ...rest }: ComponentProps<"button">): JSX.Element {
  return (
    // eslint-disable-next-line react/button-has-type
    <button className={`link-button ${className}`} type={type} {...rest} />
  );
}
